"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AqueductSystems = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Tags_1 = require("../Tags");
const CardRequirements_1 = require("../CardRequirements");
const Board_1 = require("../../boards/Board");
class AqueductSystems extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.AQUEDUCT_SYSTEMS,
            tags: [Tags_1.Tags.BUILDING],
            cost: 9,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.cities(1).any().oceans(1)),
            metadata: {
                cardNumber: 'X50',
                description: 'Requires any city adjacent to an ocean. Draw 3 building cards.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br.br;
                    b.cards(3).secondaryTag(Tags_1.Tags.BUILDING);
                }),
                victoryPoints: 1,
            },
        });
    }
    canPlay(player) {
        const board = player.game.board;
        const oceans = board.getOceansTiles(true);
        return oceans.some((ocean) => board.getAdjacentSpaces(ocean).some((space) => Board_1.Board.isCitySpace(space)));
    }
    play(player) {
        player.drawCard(3, { tag: Tags_1.Tags.BUILDING });
        return undefined;
    }
    getVictoryPoints() {
        return 1;
    }
}
exports.AqueductSystems = AqueductSystems;
//# sourceMappingURL=AqueductSystems.js.map